function hideWrapper(page) {
    const wrappers = document.querySelectorAll(".wrapper-hide");
    wrappers.forEach((wrapper) => {
        const wrapperTitle = wrapper.querySelector(".wrapper-title");

        const wrapperTitleHeight = wrapperTitle.offsetHeight;

        wrapperTitle.addEventListener("click", () => {
            if (page === 'location' && window.innerWidth <= 767) {
                if (wrapper.classList.contains("closed")) {
                    wrapper.style.maxHeight = "100em";
                } else {
                    wrapper.style.maxHeight = wrapperTitleHeight + "px";
                }
                wrapper.classList.toggle("closed");
            } else if (page === 'vacancies') {
                if (wrapper.classList.contains("closed")) {
                    wrapper.style.maxHeight = "100em";
                } else {
                    wrapper.style.maxHeight = wrapperTitleHeight + "px";
                }
                wrapper.classList.toggle("closed");
            }
        });
    });
}


export {
    hideWrapper,
}

